import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);
export default new Router({
  // mode: 'history',
  routes: [{
      path: '/',
      redirect: '/login'
    },
    {
      path: '/home',
      component: () => import('../components/common/Home.vue'),
      meta: {
        title: '自述文件'
      },
      children: [{
          // 首页下单页面
          path: '/dashboard',
          component: () => import('../components/page/order/Dashboard.vue'),
          meta: {
            title: '首页下单'
          }
        },
        {
          //未完成订单页面
          path: '/uncomplete',
          component: () => import('../components/page/uncomplete/Uncomplete.vue'),
          meta: {
            title: '未完成订单'
          }
        },
        {
          // 订单/报告查询页面  首页查询页面
          path: '/query',
          component: () => import('../components/page/query/QueryIndex.vue'),
          meta: {
            title: '订单查询'
          }
        },
        {
          // 订单/报告查询页面  报告已出/部分已出
          path: '/queryInfo',
          component: () => import('../components/page/query/QueryInfo.vue'),
          meta: {
            title: '订单详情',
            fatherPath: '/query'
          }
        },
        {
          // 订单/报告查询页面  报告已出/部分已出
          path: '/reportDetail',
          component: () => import('../components/page/query/ReportDetail.vue'),
          meta: {
            title: '查看报告',
            fatherPath: '/query'
          }
        },
        {
          // 订单/报告查询页面  报告未出
          path: '/chargeBack',
          component: () => import('../components/page/query/ChargeBack.vue'),
          meta: {
            title: '订单详情'
          }
        },
        {
          // 健康档案页面
          path: '/patient',
          component: () => import('../components/page/patient/PatientIndex.vue'),
          meta: {
            title: '健康档案'
          }
        },
        {
          // 患者档案页面
          path: '/patientFiles',
          component: () => import('../components/page/patient/PatientFiles.vue'),
          meta: {
            title: '患者档案',
            fatherPath: '/patient'
          }
        },
        {
          // 患者档案页面
          path: '/diseaseRisk',
          component: () => import('../components/page/patient/DiseaseRisk.vue'),
          meta: {
            title: '疾病风险',
            fatherPath: '/patient'
          }
        },
        {
          // 患者档案页面copy
          path: '/reportDetailCopy',
          component: () => import('../components/page/patient/reportDetailCopy.vue'),
          meta: {
            title: '报告详情',
            fatherPath: '/patient'
          }
        },
        {
          // 患者档案页面
          path: '/reportDetail',
          component: () => import('../components/page/patient/ReportDetail.vue'),
          meta: {
            title: '报告详情',
            fatherPath: '/patient'
          }
        },
        {
          // 我的诊所页面 3.0
          path: '/clinic',
          component: () => import('../components/page/clinic/Clinic.vue'),
          meta: {
            title: '我的诊所'
          }
        },
        {
          // 我的设置  免密/密码/密码
          path: '/resetIndex',
          component: () => import('../components/page/setting/ResetIndex.vue'),
          meta: {
            title: '我的设置',
            fatherPath: '/patient',
            sourcePath: "/resetIndex"
          }
        },
        {
          // 我的设置  ocr数据
          path: '/ocrData',
          component: () => import('../components/page/setting/OcrData.vue'),
          meta: {
            title: '我的设置',
            fatherPath: '/clinic',
            sourcePath: "/ocrData"
          }
        },
        {
          // 404页面
          path: '/404',
          component: () => import('../components/page/404.vue'),
          meta: {
            title: '404'
          }
        }
      ]
    },
    {
      // setting中 同云诊所申请页面
      path: '/clinicApply',
      component: () => import('../components/page/clinicApply.vue'),
      meta: {
        title: '诊所申请'
      }
    },
    {
      // setting中 小程序截长图
      path: '/screenShot',
      component: () => import('../components/page/ScreenShot.vue'),
      meta: {
        title: '图片预览'
      }
    },
    {
      // setting中 我的中健获取授权
      path: '/authorizeHs',
      component: () => import('../components/page/AuthorizeTest.vue'),
      meta: {
        title: ' '
      }
    },
    {
      // setting中 隆回报告查询
      path: '/lhReort',
      component: () => import('../components/page/lhReport.vue'),
      meta: {
        title: '报告查询'
      }
     },
    {
      // setting中  收样隐私协议
      path: '/syPrivacy',
      component: () => import('../components/page/syPrivacy.vue'),
      meta: {
        title: '隐私协议'
      }
    },
    {
      // setting中 核收端H5支付反馈页面
      path: '/payFeedback',
      component: () => import('../components/page/payFeedback.vue'),
      meta: {
        title: '支付结果'
      }
    },
    {
      // setting中登录 修改登录密码页面
      path: '/checkPassword',
      component: () => import('../components/page/setting/CheckPassword.vue'),
      meta: {
        title: '修改密码'
      }
    },
    {
      // setting中登录 重置密码页面
      path: '/resetPassword',
      component: () => import('../components/page/setting/ResetPassword.vue'),
      meta: {
        title: '重置密码'
      }
    },
     // 登录页面
    {
      path: '/login',
      component: () => import('../components/page/Login.vue'),
      meta: {
        title: '登录'
      }
    },
    // 404页面
    {
      path: '*',
      redirect: '/404'
    }
  ]
});